import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 9 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 15\" id=\"icon-chevron-right\">\n    <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-width=\"1.5\" d=\"M8.364 13.7279L2 7.3639 8.364 1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol